export default __webpack_public_path__ + "static/media/tools_ln.6c1e9d6d.svg";